module.exports = __webpack_public_path__ + "static/img/Money.3add0e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Money.png
// module id = 2241
// module chunks = 61